export const ENTRIES_PAGE_SIZE = "100";
export const TALENTS_PAGE_SIZE = "500";
export const EMPLOYER_HEALTH_INSURANCE_REDUCTIONS_PAGE_SIZE = "100";
export const PAYSLIPS_PAGE_SIZE = "100";
export const WAGE_REPORTS_PAGE_SIZE = "50";
export const CANDIDATE_INTRODUCTIONS_PAGE_SIZE = "100";
export const FEEDBACKS_PAGE_SIZE = "100";
export const MESSAGING_PAGE_SIZE = "50";
export const ORDERS_PAGE_SIZE = "100";
export const CUSTOMERS_PAGE_SIZE = "500";
export const EXCLUSIVITIES_PAGE_SIZE = 500;
export const JOB_ADS_PAGE_SIZE = "100";
